import { lazy } from 'react';

// Cards page - prefetch as commonly accessed
export const LazyCards = lazy(() => 
  import(/* webpackChunkName: "cards", webpackPrefetch: true */ '@/pages/Cards')
    .then(module => ({ default: module.Cards }))
);
